// extracted by mini-css-extract-plugin
module.exports = {"root":"category_root__30wMC","top":"category_top__2Wed9","tag":"category_tag__3k7Zl"};